.stickyComposer {
  position: sticky;
  bottom: 0;
  z-index: 10;
  background-color: var(--ant-color-bg-container);
}

.highlightedComment {
  margin: calc(-1 * var(--ant-padding-xs));
  padding: var(--ant-padding-xs);
  border-radius: var(--ant-border-radius);
  animation: fade-comment-highlight 4s ease-out forwards;
}

@keyframes fade-comment-highlight {
  0%,
  40% {
    background-color: var(--ant-color-primary-bg);
  }
  100% {
    background-color: transparent;
  }
}
